// extracted by mini-css-extract-plugin
export default {"otpContainer":"styles_otpContainer__9kreK","otpInput":"styles_otpInput__D88Mw","separator":"styles_separator__qHb+0"};